import { render, staticRenderFns } from "./staffBox.vue?vue&type=template&id=645d0629&scoped=true"
import script from "./staffBox.vue?vue&type=script&lang=js"
export * from "./staffBox.vue?vue&type=script&lang=js"
import style0 from "./staffBox.vue?vue&type=style&index=0&id=645d0629&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645d0629",
  null
  
)

export default component.exports